// 抓奸实录 · 单页首页静态数据（纯展示，虚构娱乐向）

export interface CoverItem {
  id: number;
  tag: string;
  title: string;
  desc: string;
  meta: string;
  comments: string;
  views: string;
  heat: number;
  cover: string;
  zone?: string;
}

export interface RankItem {
  id: number;
  title: string;
  summary: string;
  comments: string;
  heat: number;
  tag: string;
  trend: "up" | "new" | "steady" | "hot";
}

export interface GodComment {
  id: number;
  topic: string;
  text: string;
  author: string;
  likes: string;
  replies: string;
  tag: string;
}

export interface SceneItem {
  id: number;
  zone: string;
  title: string;
  summary: string;
  comments: string;
  views: string;
  cover: string;
  badge?: string;
}

export const NAV_LINKS = [
  { key: "hero", label: "今日封面" },
  { key: "rank", label: "热议榜" },
  { key: "god", label: "神评论" },
  { key: "scene", label: "吃瓜现场" },
  { key: "quote", label: "槽点墙" },
  { key: "faq", label: "围观须知" },
];

export const TICKER = [
  "全网都在蹲的电梯口认亲大戏 已续到第四集",
  "评论区3万条吵到凌晨 谁看了不笑",
  "监控视角合集 #社死名场面 播放破亿",
  "新晋嘴替上线 一句话把网友看爽了",
  "围观群众比当事人还急 热评直接封神",
  "吃瓜现场今晚八点加更 别错过反转",
];

// 首屏多卡
export const HERO_LEAD: CoverItem = {
  id: 0,
  tag: "今日头条",
  title: "深夜停车场手电筒直播现场 全网蹲守第4集 网友:比追剧上瘾",
  desc: "一辆蒙尘的小轿车里，手电筒一晃而过，评论区瞬间炸锅。当事人还没说话，围观群众已经替她把剧情脑补了三季——这是网友热议最上头的一集。",
  meta: "今晚 20:00 现场加更",
  comments: "8.4万",
  views: "1.2亿",
  heat: 99,
  cover: "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20art%20warm%20crimson%20and%20cream%20palette%20halftone%20newsprint%20texture%20a%20dramatic%20spotlight%20on%20a%20crowd%20of%20anonymous%20people%20watching%20a%20huge%20screen%20holding%20popcorn%20with%20shocked%20amused%20expressions%20vintage%20bold%20editorial%20layout%20stylized%20not%20realistic%20high%20contrast&width=1600&height=900&seq=cover-hero-lead-1&orientation=landscape",
};

export const HERO_STACK: CoverItem[] = [
  {
    id: 1,
    tag: "热议",
    title: "电梯口认亲名场面 被反杀前当事人如何三连否认",
    desc: "监控视角+楼层按钮实录，围观群众直呼比谍战片还精彩。",
    meta: "网友热议中",
    comments: "3.1万",
    views: "8600万",
    heat: 96,
    cover: "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20art%20warm%20crimson%20and%20cream%20palette%20halftone%20texture%20a%20mysterious%20person%20in%20hat%20and%20sunglasses%20peeking%20through%20a%20door%20crack%20with%20dramatic%20spotlight%20comedic%20vintage%20bold%20typography%20stylized%20illustration%20not%20realistic%20high%20contrast&width=800&height=1000&seq=cover-stack-01&orientation=portrait",
  },
  {
    id: 2,
    tag: "神评论",
    title: "一张小票引发的神评论 嘴替姐姐一句话封神",
    desc: "购物小票被摊开的一瞬，评论区高能回复排山倒海。",
    meta: "评论区爆了",
    comments: "2.7万",
    views: "6400万",
    heat: 94,
    cover: "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20art%20warm%20crimson%20and%20cream%20palette%20halftone%20texture%20a%20hand%20holding%20a%20small%20flashlight%20at%20night%20dramatic%20comedic%20spy%20feeling%20vintage%20bold%20editorial%20typography%20stylized%20illustration%20not%20realistic%20high%20contrast&width=800&height=1000&seq=cover-stack-02&orientation=portrait",
  },
];

export const HERO_MINI = [
  { id: 1, title: "隔江对峙的窗户 双双拉帘后评论区笑疯", hot: "96" },
  { id: 2, title: "错送同款零食当场社死 店家留言火了", hot: "91" },
  { id: 3, title: "车库后备箱钻出的小哥 成了全网教材", hot: "88" },
  { id: 4, title: "代收快递的乌龙 网友:这波是互相伤害", hot: "84" },
  { id: 5, title: "电话静音之谜破解 热评给出标准答案", hot: "80" },
];

// 热议榜
export const RANK_LIST: RankItem[] = [
  {
    id: 1,
    title: "深夜停车场直播合集 评论区吵到凌晨四点",
    summary: "吃瓜现场围观人数持续走高，围观群众从定罪到洗白吵了三轮，最后由一条神评论统一口径。",
    comments: "8.4万",
    heat: 99,
    tag: "现场直击",
    trend: "hot",
  },
  {
    id: 2,
    title: "电梯口被叫住名场面 当事人三连否认被网友逐帧拆解",
    summary: "抓奸实录评论区把监控时间线拉成字幕，高能回复把破绽一一标注，堪称阅读理解教科书。",
    comments: "5.6万",
    heat: 96,
    tag: "网友热议",
    trend: "up",
  },
  {
    id: 3,
    title: "一张购物小票定乾坤 嘴替姐姐在线封神",
    summary: "神评论诞生现场：一句高能回复把全场气氛顶到最高，点赞数半天冲上讨论广场榜首。",
    comments: "4.9万",
    heat: 95,
    tag: "神评论",
    trend: "new",
  },
  {
    id: 4,
    title: "隔江对窗双双拉帘 评论区秒变侦探小组",
    summary: "画面没有一句台词，抓奸实录网友热议却脑补出完整剧本，结局出人意料。",
    comments: "3.8万",
    heat: 92,
    tag: "吃瓜现场",
    trend: "up",
  },
  {
    id: 5,
    title: "错送同款零食当场社死 店家回应成彩蛋",
    summary: "围观群众笑到缺氧，店家在评论区现身说法，网友:这才是本期隐藏主角。",
    comments: "3.2万",
    heat: 90,
    tag: "神评论",
    trend: "steady",
  },
  {
    id: 6,
    title: "车库后备箱钻出的小哥 全网奉为反面教材",
    summary: "一段监控被反复截图，抓奸实录评论区高能回复一条接一条，讲得头头是道。",
    comments: "2.9万",
    heat: 88,
    tag: "监控合集",
    trend: "up",
  },
  {
    id: 7,
    title: "代收快递的惊天乌龙 网友直呼互相伤害",
    summary: "一件快递引出三条故事线，围观群众表示:这波谁都不冤，评论区风向三连跳。",
    comments: "2.4万",
    heat: 85,
    tag: "网友热议",
    trend: "steady",
  },
  {
    id: 8,
    title: "手机静音之谜破解 热评给出教科书式结论",
    summary: "抓奸实录讨论广场里最火的推理贴，高能回复条理清晰，连本人都看愣了。",
    comments: "1.9万",
    heat: 83,
    tag: "讨论广场",
    trend: "new",
  },
];

export const RANK_TABS = ["24小时", "本周", "本月"];

// 神评论精选
export const GOD_COMMENTS: GodComment[] = [
  {
    id: 1,
    topic: "深夜停车场直播合集",
    text: "当事人：我什么都没干。监控：你确定吗？你身后那位都开始尴尬挠头了。",
    author: "@今晚必吃瓜",
    likes: "12.8万",
    replies: "3400",
    tag: "封神",
  },
  {
    id: 2,
    topic: "电梯口被叫住名场面",
    text: "别问为什么楼层按了三遍没走，因为电梯也想看完再关门。",
    author: "@楼下的热心肠",
    likes: "9.6万",
    replies: "2100",
    tag: "嘴替",
  },
  {
    id: 3,
    topic: "隔江对窗双双拉帘",
    text: "两扇窗帘同时落下，像极了我俩同时划掉聊天记录的样子。",
    author: "@专业背锅侠",
    likes: "8.1万",
    replies: "980",
    tag: "金句",
  },
  {
    id: 4,
    topic: "车库后备箱钻出的小哥",
    text: "建议把这段投给驾校当应急演练教材：学员钻后备箱，教练震惊三连。",
    author: "@驾考没考过",
    likes: "7.4万",
    replies: "1200",
    tag: "高能",
  },
  {
    id: 5,
    topic: "错送同款零食当场社死",
    text: "这不是买错了，这是人生走错了楼层。",
    author: "@人间清醒鹅",
    likes: "6.2万",
    replies: "760",
    tag: "嘴替",
  },
  {
    id: 6,
    topic: "代收快递的惊天乌龙",
    text: "快递没错，地址没错，错的是我以为你没以为。",
    author: "@不抬杠浑身痒",
    likes: "5.5万",
    replies: "640",
    tag: "金句",
  },
];

export const GOD_TABS = ["本日精选", "高能Top", "嘴替榜"];

// 吃瓜现场分区
export const SCENE_ZONES = [
  { key: "all", name: "全部现场", icon: "ri-fire-fill" },
  { key: "hotel", name: "酒店现场", icon: "ri-door-open-line" },
  { key: "elevator", name: "电梯/楼道", icon: "ri-reserved-line" },
  { key: "parking", name: "停车场", icon: "ri-car-line" },
  { key: "home", name: "家中对质", icon: "ri-home-smile-line" },
  { key: "street", name: "街头撞见", icon: "ri-map-pin-line" },
];

export const SCENES: SceneItem[] = [
  {
    id: 1,
    zone: "hotel",
    title: "走廊零点准时报到 双人份夜宵成全场笑点",
    summary: "服务员送餐撞了个正着，围观群众表示这位小哥的临场反应能上春晚。",
    comments: "2.6万",
    views: "4100万",
    cover: "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20art%20warm%20crimson%20and%20cream%20halftone%20texture%20a%20mysterious%20silhouette%20peeking%20around%20a%20hotel%20corridor%20corner%20dramatic%20spotlight%20comedic%20suspense%20vintage%20bold%20typography%20stylized%20illustration%20not%20realistic&width=900&height=600&seq=scene-hotel-1&orientation=landscape",
  },
  {
    id: 2,
    zone: "elevator",
    title: "电梯门开的一瞬间 双方对视全场石化",
    summary: "狭小空间里空气凝固，抓奸实录网友热议一致给这段打满分运镜。",
    comments: "1.9万",
    views: "3200万",
    cover: "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20art%20warm%20crimson%20and%20cream%20halftone%20texture%20two%20stylized%20silhouette%20faces%20staring%20at%20each%20other%20inside%20an%20open%20elevator%20dramatic%20light%20comedic%20awkward%20vintage%20bold%20typography%20stylized%20illustration%20not%20realistic&width=900&height=600&seq=scene-elevator-1&orientation=landscape",
  },
  {
    id: 3,
    zone: "parking",
    title: "车库灯光扫过的三秒 是本期悬疑巅峰",
    summary: "手电筒、后备箱、蒙尘车窗轮番登场，评论区上演推理大会。",
    comments: "3.4万",
    views: "5600万",
    cover: "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20art%20warm%20crimson%20and%20cream%20halftone%20texture%20car%20headlights%20sweeping%20across%20an%20empty%20parking%20garage%20at%20night%20dramatic%20suspenseful%20comedic%20vintage%20bold%20typography%20stylized%20illustration%20not%20realistic&width=900&height=600&seq=scene-parking-1&orientation=landscape",
  },
  {
    id: 4,
    zone: "home",
    title: "茶几上那杯双人份奶茶 沉默比咆哮更致命",
    summary: "一段家庭对质实录，抓奸实录评论区把双方微表情逐帧做成表情包。",
    comments: "2.2万",
    views: "2800万",
    cover: "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20art%20warm%20crimson%20and%20cream%20halftone%20texture%20a%20stylized%20living%20room%20with%20two%20milk%20tea%20cups%20on%20a%20coffee%20table%20under%20a%20single%20lamp%20moody%20comedic%20tension%20vintage%20bold%20typography%20stylized%20illustration%20not%20realistic&width=900&height=600&seq=scene-home-1&orientation=landscape",
  },
  {
    id: 5,
    zone: "street",
    title: "街头牵手被目击 那位大姐的嗓门盖过全场",
    summary: "热心路人当场开麦，围观群众还没反应过来就被一句高能回复逗笑。",
    comments: "1.6万",
    views: "2300万",
    cover: "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20art%20warm%20crimson%20and%20cream%20halftone%20texture%20a%20busy%20city%20street%20corner%20at%20dusk%20stylized%20crowd%20of%20onlookers%20pointing%20and%20whispering%20dramatic%20lighting%20comedic%20vintage%20bold%20typography%20stylized%20illustration%20not%20realistic&width=900&height=600&seq=scene-street-1&orientation=landscape",
  },
  {
    id: 6,
    zone: "hotel",
    title: "凌晨一点双开门的文学 被服务员一秒终结",
    summary: "门开了又关、关了又开，抓奸实录讨论广场这贴回复量暴涨。",
    comments: "1.3万",
    views: "1900万",
    cover: "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20art%20warm%20crimson%20and%20cream%20halftone%20texture%20two%20adjacent%20hotel%20room%20doors%20opening%20toward%20each%20other%20late%20night%20hallway%20dramatic%20comedic%20vintage%20bold%20typography%20stylized%20illustration%20not%20realistic&width=900&height=600&seq=scene-hotel-2&orientation=landscape",
  },
  {
    id: 7,
    zone: "elevator",
    title: "地下二层按下又取消的楼层 评论区给出标准解读",
    summary: "一个按错又改的动作，被网友热议拆成连续剧级的心理戏。",
    comments: "1.1万",
    views: "1500万",
    cover: "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20art%20warm%20crimson%20and%20cream%20halftone%20texture%20a%20hand%20hovering%20over%20elevator%20floor%20buttons%20dim%20basement%20lighting%20suspenseful%20comedic%20vintage%20bold%20typography%20stylized%20illustration%20not%20realistic&width=900&height=600&seq=scene-elevator-2&orientation=landscape",
  },
  {
    id: 8,
    zone: "street",
    title: "广场舞大妈集体停下 整齐划一围观新剧本",
    summary: "音乐都停了，大姐们的八卦天线却支棱起来，这画面很难不笑。",
    comments: "9800",
    views: "1200万",
    cover: "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20art%20warm%20crimson%20and%20cream%20halftone%20texture%20a%20group%20of%20elderly%20women%20in%20matching%20dance%20outfits%20gathering%20in%20a%20circle%20to%20gossip%20at%20a%20public%20square%20evening%20light%20comedic%20warm%20vintage%20bold%20typography%20stylized%20illustration%20not%20realistic&width=900&height=600&seq=scene-street-2&orientation=landscape",
  },
];

// 槽点墙金句
export const QUOTES = [
  { id: 1, text: "这波我站监控，它看得最清楚还从不带节奏。", tag: "高赞" },
  { id: 2, text: "当事人：误会。监控：不，是连续剧。", tag: "高赞" },
  { id: 3, text: "别慌，先看看评论区，嘴替马上替你说话。", tag: "本周" },
  { id: 4, text: "你以为是偶遇，其实是巧合他编不下去了。", tag: "金句" },
  { id: 5, text: "围观可以，代入要适度，别把自己气哭了。", tag: "暖评" },
  { id: 6, text: "真相只有一个，但评论区能给三百万个。", tag: "高赞" },
  { id: 7, text: "聊归聊，骂归骂，蹲完记得好好睡觉。", tag: "暖评" },
  { id: 8, text: "每一集看完我都觉得自己能当导演了。", tag: "金句" },
];

// 围观须知 FAQ
export const FAQ = [
  {
    q: "抓奸实录里这些现场是从哪来的？",
    a: "抓奸实录讨论广场聚合的是网友自发投稿、搬运并打码的公开监控与自拍影像，配合抓奸实录网友热议里的转发与解读呈现。内容都经过打码与虚构化处理，仅供娱乐讨论，不代表任何真实当事人立场。",
  },
  {
    q: "为什么评论区都在刷“神评论”和“嘴替”？",
    a: "当一段现场配上一句精准到家的高能回复，围观群众就会集体刷屏点赞。抓奸实录神评论栏目专门把这类评论捞出来置顶，方便你三秒get到讨论广场的高光。",
  },
  {
    q: "我刷到内容后怎么参与讨论？",
    a: "每一张现场卡右上角的讨论入口、评论区与热度数字都可以点开围观。你可以潜水看抓奸实录评论区，也可以发表自己的高能回复——本期只是静态演示，正式上线后一键即可发言。",
  },
  {
    q: "内容会不会冒犯到当事人？",
    a: "我们会坚持三原则：人物一律打码、事件一律虚构化表述、评论区提倡理性吃瓜。若你发现任何不妥内容，欢迎举报，我们将第一时间下架——理性围观，是我们的底线。",
  },
  {
    q: "吃瓜现场多久更新一次？",
    a: "抓奸实录网友热议的热点流动很快，我们按热度实时排序加更。本期为单页演示版，正式版会根据讨论广场活跃度滚动刷新榜单与神评论。",
  },
];

export const TRUST = [
  { icon: "ri-shield-check-line", title: "打码先行", desc: "所有人物一律打码，只聊现象不指认真人" },
  { icon: "ri-file-text-line", title: "虚构化表述", desc: "剧情向解读，不追求坐实任何真实身份" },
  { icon: "ri-flag-line", title: "理性引导", desc: "评论区倡导就事论事，反对人身攻击" },
  { icon: "ri-archive-line", title: "一键下架", desc: "任何不适内容举报即处理，绝不拖延" },
];

export const ZONE_LINKS = [
  { name: "酒店现场", tag: "深夜文学" },
  { name: "电梯楼道", tag: "电梯相遇学" },
  { name: "停车场", tag: "车灯探案" },
  { name: "家中对质", tag: "餐桌修罗场" },
  { name: "街头撞见", tag: "路人广播站" },
  { name: "监控合集", tag: "监控美学" },
];

export const SIDE_TOPICS = [
  { name: "#社死名场面", hot: "1260万" },
  { name: "#监控视角", hot: "980万" },
  { name: "#神评论高光", hot: "860万" },
  { name: "#网友热议榜", hot: "730万" },
  { name: "#吃瓜日历", hot: "510万" },
];